import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "impx-slide-container hp9 uk-padding uk-padding-remove-horizontal uk-padding-remove-bottom uk-background-fixed uk-background-center-center uk-height-1-1" }
const _hoisted_2 = { class: "uk-container uk-margin-top impx-margin-top-small" }
const _hoisted_3 = {
  class: "uk-width-1-1",
  style: {"height":"560px !important"}
}
const _hoisted_4 = { class: "uk-flex uk-flex-left uk-position-bottom uk-margin-left uk-margin-bottom" }
const _hoisted_5 = { class: "uk-light uk-position-relative uk-text-left page-title" }
const _hoisted_6 = { class: "uk-margin-remove" }
const _hoisted_7 = { class: "impx-text-large uk-margin-remove" }



export default /*@__PURE__*/_defineComponent({
  __name: 'ContactHeading',
  props: {
  hero:{}
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "impx-overlay dark" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", _hoisted_6, _toDisplayString(props.hero?.title), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(props.hero?.subtitle), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})